import { useApplicationStore } from "@/stores/Application";
import { linkItems } from "@/components/Header/types";
import type { RouteLocationNormalized } from 'vue-router';

export default defineNuxtRouteMiddleware((_to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    const {setIsLoadingPageIndicator} = useApplicationStore();
    if(from.path === linkItems.root.routerPath){
        return;
    }
    setIsLoadingPageIndicator(true);
});
